import AOS from "aos";
AOS.init({
  disable: 'mobile',
  duration: 500,
  easing: 'ease-out-quad',
  once: true,
});
